import React, { createContext, useContext, useState } from "react";

const TooltipContext = createContext();

export const TooltipProvider = ({ children }) => {
  const [activeTooltip, setActiveTooltip] = useState(null);

  const showTooltip = (id) => setActiveTooltip(id);
  const hideTooltip = () => setActiveTooltip(null);

  return (
    <TooltipContext.Provider
      value={{ activeTooltip, showTooltip, hideTooltip }}
    >
      {children}
    </TooltipContext.Provider>
  );
};

export const useTooltip = () => useContext(TooltipContext);
